import React, { Fragment } from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsList from '../../../../components/newsList';

class ContentList extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { newsTop, newsList0, newsList1, shopInNews0, shopInNews1 },
        } = this.props;

        return (
            <Fragment>
                <NoSSR>
                    <Chip
                        id="255934"
                        type="recommend"
                        title="要闻置顶"
                        groupName="要闻区"
                        content={newsTop}
                        translate="handleNewsTopData">
                        <NewsList hasTitle isBig isUnfold size="long" />
                    </Chip>
                </NoSSR>
                <NoSSR>
                    <Chip
                        id="285555"
                        type="recommend"
                        title="要闻列表1"
                        groupName="要闻区"
                        content={newsList0}
                        translate="handleNewsListData">
                        <NewsList size="long" isUnfold marquee />
                    </Chip>
                </NoSSR>
                <Chip
                    id="255852"
                    type="recommend"
                    title="要闻区电商1"
                    groupName="要闻区"
                    content={shopInNews0}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225732"
                    type="recommend"
                    title="要闻列表2"
                    groupName="要闻区"
                    content={newsList1}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
                <Chip
                    id="225733"
                    type="recommend"
                    title="要闻区电商2"
                    groupName="要闻区"
                    content={shopInNews1}
                    translate="handleNewsData">
                    <NewsList size="long" />
                </Chip>
            </Fragment>
        );
    }
}

export default errorBoundary(ContentList);
